import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from './messages';
import style from './style.module.less';
import { PromotionalBanner } from '../../../../../../components/promotional-banner';
import { linkIDs } from '../../../../../../services/link-service/links';
import { useSupportLink } from '../../../hooks';

/**
 * This banner is used when the current Seller does not have ShipStationApiV2 feature enabled
 * but the InventoryApi.
 * @returns {JSX.Element} The rendered component.
 */
export const InventoryPromotionalBanner = () => {
  const link = useSupportLink(linkIDs.PaymentAndSubscriptionSettings);

  return (
    <PromotionalBanner
      className={style['inventory-banner']}
      promotionalHeaderMessage={messages.title}
      promotionalSubheaderMessage={messages.content}
    >
      <Button className={style['inventory-banner-button']} href={link} theme='promotional'>
        <FormattedMessage {...messages.button} />
      </Button>
    </PromotionalBanner>
  );
};
